import {
	AtSignIcon,
	UserRoundCheckIcon,
	ClockIcon,
	AlarmClockIcon,
	ActivityIcon,
	UsersIcon,
	UserPlusIcon,
	PlusIcon,
	MailIcon,
	TriangleAlertIcon
} from "lucide-react"
import { formatDistanceToNow } from "date-fns"
import { Link } from "~/components/Link"
import { Item } from "~/components/ui/item"
import { cn, enumFormat } from "~/lib/utils"
import type { RouterOutputs } from "~/trpc/react"

export function NotificationRow({
	notification,
	selected,
	to
}: {
	notification: RouterOutputs["notifications"]["listInbox"][number]
	selected?: boolean
	to: string
}) {
	const Icon = {
		ProjectUpdate: ActivityIcon,
		Mention: AtSignIcon,
		Assignment: UserRoundCheckIcon,
		UpcomingDueDate: ClockIcon,
		PastDueDate: AlarmClockIcon,
		WatchedIssueActivity: ActivityIcon,
		JoinedOrg: UsersIcon,
		JoinedTeam: UserPlusIcon,
		TeamCreated: PlusIcon,
		TeamInvite: MailIcon,
		DeliveryFailure: TriangleAlertIcon
	}[notification.kind]
	return (
		<Item asChild variant="interactive" size="row">
			<Link
				id={`notification-${notification.id}`}
				to={to}
				aria-current={selected ? "true" : undefined}
				className={cn(
					"group grid grid-cols-[auto_minmax(0,1fr)] rounded-lg text-left",
					selected && "bg-active ring-1 ring-stroke"
				)}
			>
				<span
					className={cn(
						"relative flex size-8 items-center justify-center rounded-md bg-background text-text-small",
						!notification.readAt && "bg-orbit/10 text-orbit-text"
					)}
				>
					<Icon className="size-4" />
					{!notification.readAt && (
						<span
							className="absolute -right-0.5 -top-0.5 size-2 rounded-full bg-orbit"
							aria-label="Unread"
						/>
					)}
				</span>
				<span className="min-w-0">
					<span className="mb-0.5 flex items-center justify-between gap-2 text-xs text-text-small">
						<span className="truncate">{enumFormat(notification.kind)}</span>
						<time
							className="shrink-0"
							dateTime={new Date(notification.createdAt).toISOString()}
						>
							{formatDistanceToNow(notification.createdAt, {
								addSuffix: false
							})}
						</time>
					</span>
					<span
						className={cn(
							"block truncate text-sm text-text-main",
							!notification.readAt && "font-medium"
						)}
					>
						{notification.title}
					</span>
					<span className="mt-0.5 line-clamp-2 text-xs leading-5 text-text-sub">
						{notification.body}
					</span>
				</span>
			</Link>
		</Item>
	)
}
